import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingCheckService } from '../services/onboarding-check.service';
import { TokenService } from '../services/token.service';
import { map, catchError, of } from 'rxjs';

export const onboardingGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const onboardingService = inject(OnboardingCheckService);
  const tokenService = inject(TokenService);

  const user = tokenService.user;
  /* 🔥 IF NOT NEW USER → ALWAYS DASHBOARD */
  const fromDashboard = route.queryParamMap.get('fromDashboard') === 'true';
  const fromDeviceSetup =
  route.queryParamMap.get('fromDeviceSetup') === 'true';

  /* 🔥 EXISTING USER (NOT NEW) */
  if (user && user.isNewUser === false) {

    // ✅ If manually adding vehicle from dashboard → allow setup
    if (fromDashboard || fromDeviceSetup) {
      return true;
    }

    // ❌ Otherwise always dashboard
    if (!state.url.startsWith('/dashboard')) {
      return router.createUrlTree(['/dashboard']);
    }

    return true;
  }

  return onboardingService.getStep().pipe(

    map((res: any) => {

      const step = res?.data?.step;

      /* DEVICE CLAIM */
      if (step === 'DEVICE_CLAIM' || step === 'NONE') {
        return state.url.startsWith('/setup/device-setup')
          ? true
          : router.createUrlTree(['/setup/device-setup']);
      }

      /* VEHICLE CONNECT */
      if (step === 'VEHICLE_CONNECT') {
        return state.url.startsWith('/setup/vehicle-connection')
          ? true
          : router.createUrlTree(['/setup/vehicle-connection']);
      }

      /* PERSONALISE */
      if (step === 'PERSONALISE') {

        const hasStepQuery = route.queryParamMap.get('step') === 'PERSONALISE';

        if (state.url.startsWith('/setup/vehicle-connection') && hasStepQuery) {
          return true;
        }

        return router.createUrlTree(
          ['/setup/vehicle-connection'],
          { queryParams: { step: 'PERSONALISE' } }
        );
      }

      /* COMPLETED */
      if (step === 'COMPLETED') {
        if (state.url.startsWith('/setup') && !fromDashboard) {
          return router.createUrlTree(['/dashboard']);
        }
      }

      return true;
    }),

    catchError((err) => {
      if (err.status === 401) {
        return of(router.createUrlTree(['/auth/sign-in']));
      }
      return of(router.createUrlTree(['/dashboard']));
    })
  );
};
